var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H4C1.79086 0 0 1.79086 0 4V12H8C10.2091 12 12 10.2091 12 8V0Z",
    fill: "#FCD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderM);
export default __webpack_public_path__ + "static/media/border-m.356b8ce4e9088c5096b24f46c1eb7867.svg";
export { ForwardRef as ReactComponent };